import { TimerType } from "../../model/exam/timer-type.enum";

export class TimedBlockEntity {
	public index!: number;
	public sectionId?: string;
	public type!: TimerType;
}
